import styled from "styled-components";

export const MultiWeekPlannerMainContainer = styled("section")`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const TableSection = styled("div")`
  flex: 1;
  display: flex;
  padding: 1em;
  flex-direction: column;
  align-items: stretch;
`;

export const AssumptionSummaryText = styled("h3")`
  text-align: center;
`;

export const VisualisationSection = styled("div")`
  flex: 1;
  display: flex;
  align-items: stretch;
`;

export const VolumeGridWrapper = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const VolumeGridRow = styled("div")`
  display: flex;
  flex-direction: row;
`;

export const TableWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  &:last-child {
    border-bottom: none;
  }
`;

export const TableRow = styled("div")`
  display: flex;
  flex-direction: row;
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
  & .headercell {
    background-color: #e0e0e0;
    color: black;
    font-weight: bold;
  }
`;

export const FigureRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  &:nth-child(2n) {
    background: #eee;
  }

  &:first-child {
    background: #2196f377;
  }
`;

export const TableCell = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0.5em;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  &:last-of-type: {
    borde: none;
  }
`;
